export default __webpack_public_path__ + "media/images/react_icons/property/map-6f562245e5e603432468cf4a86e40311.svg";